import React from "react";
import { _cs } from "@togglecorp/fujs";

import ListView from "#rscv/List/ListView";

import styles from "./styles.module.scss";

export interface ReportItem {
  id: number;
  title: string;
  [key: string]: unknown;
}

export interface SidePaneProps {
  className?: string;
  reports?: ReportItem[];
  selectedReport?: number;
  onSelectedReportChange: (selectedReport: number) => void;
}

const Report: React.FC<{
  className?: string;
  title: string;
  isActive?: boolean;
  onClick: () => void;
}> = ({ className, title, isActive, onClick }) => (
  <button
    className={_cs(styles.report, className, isActive && styles.active)}
    type="button"
    onClick={onClick}
  >
    {title}
  </button>
);

export default class SituationReportSidePane extends React.PureComponent<SidePaneProps> {
  static defaultProps: Partial<SidePaneProps> = {
    className: undefined,
    selectedReport: undefined,
    reports: [],
  };

  private reportRendererParams = (key: number, data: ReportItem) => ({
    title: data.title,
    onClick: () => this.props.onSelectedReportChange(key),
    isActive: key === this.props.selectedReport,
  });

  render() {
    const { className, reports } = this.props;

    if (!reports || reports.length === 0) {
      return null;
    }

    const reportKeySelector = (d: ReportItem) => d.id;

    return (
      <ListView
        className={_cs(styles.sidePane, className)}
        data={reports}
        keySelector={reportKeySelector}
        renderer={Report}
        rendererParams={this.reportRendererParams}
      />
    );
  }
}
